import * as mutationTypes from './mutation-types'
import api from '@/store/api/customer/product/bundle'

const initialState = () => ({
    bundle: {}
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        bundle: state => state.bundle
    },
    actions: {
        /**
         * @param {{customerId: number, params: {}}} data
         * @returns {Promise<*>}
         */
        showBundle: async ({commit, dispatch}, data) => {
            try {
                const response = await api.showBundle(data)
                const bundle = response.data

                commit(mutationTypes.SET_CUSTOMER_BUNDLE, bundle)

                return bundle
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        createBundle: async ({ dispatch }, data) => {
            try {
                return await api.createBundle(data)
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        updateBundle: async ({ dispatch }, data) => {
            try {
                return await api.updateBundle(data)
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetBundle: ({commit}) => commit(mutationTypes.RESET_CUSTOMER_BUNDLE)
    },
    mutations: {
        [mutationTypes.RESET_CUSTOMER_BUNDLE]: (state) => Object.assign(state, initialState()),
        [mutationTypes.SET_CUSTOMER_BUNDLE]: (state, data) => state.bundle = data
    }
}
